import { render, staticRenderFns } from "./BtnCurrentAcounts.vue?vue&type=template&id=3a207db9&"
import script from "./BtnCurrentAcounts.vue?vue&type=script&lang=js&"
export * from "./BtnCurrentAcounts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports